(function() {

    const contactTripType = document.querySelectorAll('select[name="contact[TripType]"]');
    contactTripType.forEach(function (item) {
        item.addEventListener('change', function (event) {
            const form = event.target.closest('form');
            let dropoffAddressWrap = form.querySelector('#Drop-off-Address');
            if (event.target.value == 'One way') {
                dropoffAddressWrap.style.display = 'block';
                dropoffAddressWrap.querySelectorAll('input').forEach((input) => {
                    input.removeAttribute('disabled');
                });
            } else {
                dropoffAddressWrap.style.display = 'none';
                dropoffAddressWrap.querySelectorAll('input').forEach((input) => {
                    input.setAttribute('disabled', '');
                });
            }
        });
    });

    const requestQuoteButton = document.querySelector('button[data-button="requestQuote"]');
    if (requestQuoteButton) {
        requestQuoteButton.addEventListener('click', function(event) {
            event.preventDefault();
            var error = 0
                form = this.closest('form');
            
            var firstName = form.querySelector('input[name="contact[First Name]"]'),
                lastName = form.querySelector('input[name="contact[Last Name]"]'),
                email = form.querySelector('input[name="contact[email]"]'),
                phone = form.querySelector('input[name="contact[phone]"]'),
                tripType = form.querySelector('select[name="contact[TripType]"]'),
                pickupDate = form.querySelector('input[name="contact[Pickup Date]"]'),
                pickupTime = form.querySelector('input[name="contact[Pickup Time]"]'),
                pickupAddress = form.querySelector('input[name="contact[Pick-up Address]"]'),
                pickupSuburb = form.querySelector('input[name="contact[Pickup Suburb]"]'),
                pickupState = form.querySelector('input[name="contact[Pickup State/Territory]"]'),
                pickupPostcode = form.querySelector('input[name="contact[Pickup Postcode]"]'),
                dropoffAddress = form.querySelector('input[name="contact[Dropoff Address]"]'),
                dropoffSuburb = form.querySelector('input[name="contact[Dropoff Suburb]"]'),
                dropoffState = form.querySelector('input[name="contact[Dropoff State/Territory]"]'),
                dropoffPostcode = form.querySelector('input[name="contact[Dropoff Postcode]"]'),
                occassion = form.querySelector('select[name="contact[Occassion]"]'),
                totalPassengers = form.querySelector('select[name="contact[Total Passengers]"]'),
                vehicleSelector = form.querySelector('[data-vehicle]'),
                vehicles = form.querySelectorAll('input[type="checkbox"]:checked'),
                formTerms = form.querySelector('#form_terms');
            
            var parent = firstName.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (firstName.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">First Name is required</span>');
                firstName.focus();
                return false;
            }
            var parent = lastName.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (lastName.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Last Name is required</span>');
                lastName.focus();
                return false;
            }
            var parent = email.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (email.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Email is required</span>');
                email.focus();
                return false;
            }

            var parent = phone.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (phone.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Phone is required</span>');
                phone.focus();
                return false;
            }

            var parent = tripType.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (tripType.options[tripType.selectedIndex].value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Trip Type is required</span>');
                tripType.focus();
                return false;
            }

            var parent = pickupDate.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupDate.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup date is required</span>');
                pickupDate.focus();
                return false;
            }

            var parent = pickupTime.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupTime.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup time is required</span>');
                pickupTime.focus();
                return false;
            }

            var parent = pickupAddress.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupAddress.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup Address is required</span>');
                pickupAddress.focus();
                return false;
            }

            var parent = pickupSuburb.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupSuburb.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup Suburb is required</span>');
                pickupSuburb.focus();
                return false;
            }

            var parent = pickupState.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupState.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup State is required</span>');
                pickupState.focus();
                return false;
            }

            var parent = pickupPostcode.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (pickupPostcode.value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Pickup Postcode is required</span>');
                pickupPostcode.focus();
                return false;
            }

            if (tripType.value == 'One way') {
                var parent = dropoffAddress.parentElement;
                if (parent.lastElementChild.classList.contains('error')) {
                    parent.lastElementChild.remove();
                }
                if (dropoffAddress.value == '') {
                    error = 1;
                    parent.insertAdjacentHTML('beforeend', '<span class="error">Drop-off Address is required</span>');
                    dropoffAddress.focus();
                    return false;
                }

                var parent = dropoffSuburb.parentElement;
                if (parent.lastElementChild.classList.contains('error')) {
                    parent.lastElementChild.remove();
                }
                if (dropoffSuburb.value == '') {
                    error = 1;
                    parent.insertAdjacentHTML('beforeend', '<span class="error">Drop-off Suburb is required</span>');
                    dropoffSuburb.focus();
                    return false;
                }

                var parent = dropoffState.parentElement;
                if (parent.lastElementChild.classList.contains('error')) {
                    parent.lastElementChild.remove();
                }
                if (dropoffState.value == '') {
                    error = 1;
                    parent.insertAdjacentHTML('beforeend', '<span class="error">Drop-off State is required</span>');
                    dropoffState.focus();
                    return false;
                }

                var parent = dropoffPostcode.parentElement;
                if (parent.lastElementChild.classList.contains('error')) {
                    parent.lastElementChild.remove();
                }
                if (dropoffPostcode.value == '') {
                    error = 1;
                    parent.insertAdjacentHTML('beforeend', '<span class="error">Drop-off Postcode is required</span>');
                    dropoffPostcode.focus();
                    return false;
                }
            }

            var parent = occassion.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (occassion.options[occassion.selectedIndex].value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Occassion is required</span>');
                occassion.focus();
                return false;
            }

            var parent = totalPassengers.parentElement;
            if (parent.lastElementChild.classList.contains('error')) {
                parent.lastElementChild.remove();
            }
            if (totalPassengers.options[totalPassengers.selectedIndex].value == '') {
                error = 1;
                parent.insertAdjacentHTML('beforeend', '<span class="error">Total Passengers is required</span>');
                totalPassengers.focus();
                return false;
            }
            
            if (vehicleSelector.lastElementChild.classList.contains('error')) {
                vehicleSelector.lastElementChild.remove();
            }
            if (vehicles.length == 0) {
                error = 1;
                vehicleSelector.insertAdjacentHTML('beforeend', '<span class="error">Vehicle is required</span>');
                return false;
            }

            var parent = formTerms.parentElement;
            if (parent.nextElementSibling && parent.nextElementSibling.classList.contains('error')) {
                parent.nextElementSibling.remove();
            }
            if (!formTerms.checked) {
                error = 1;
                parent.insertAdjacentHTML('afterend', '<span class="error">Accept terms & conditions</span>');
                formTerms.focus();
                return false;
            }
            
            if (error == 0) {
                form.submit();
            }
        });
    }
})();


